import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';
import ConnexionModule from '../../components/ConnexionModule';
import { selectIsLoggedIn } from '../../reducers/client';

const StyledImg = styled.img`
  border-radius: 24px;
  @media (max-width: ${(p) => p.theme.breakpoints.lg}) {
    border-radius: 16px;
  }
`;

const RepairLogin = () => {
  const { t } = useTranslation();
  const isLoggedIn = useSelector((state) => selectIsLoggedIn(state));
  const autodiag = useSelector((state) => state.autodiag.autodiag);

  console.log('autodiag:', autodiag); // Debugging line

  // if (autodiag !== 'v2') {
  //   console.log('returning autodiag:', autodiag); // Debugging line
  //   return <Redirect to={'/reparation/symptoms'} />;
  // }

  // Devis-rebook and standard flows both land on /reparation/confirmation
  // post-login. source_visit_report_id stays in Redux state and is forwarded
  // by RepairConfirmation when POSTing /courses.
  const postLoginPath = '/reparation/confirmation';
  const redirAfterLogin = 'reparation';

  return (
    <div>
      {isLoggedIn ? (
        <Redirect to={postLoginPath} />
      ) : (
        <ConnexionModule
          redir={redirAfterLogin}
          titleSignin={t('repairlogin.titlesignin')}
          ctaLabelSignin={t('repairlogin.ctasignin')}
          titleSignup={t('repairlogin.titlesignup')}
          ctaLabelSignup={t('repairlogin.ctasignup')}
        />
      )}
    </div>
  );
};

export default RepairLogin;
